import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatDate } from "@/lib/api";
import { CalendarClock } from "lucide-react";

// Dashboard banner: surfaces scheduled regional minimum-wage adjustments
// (Wage Orders) so HR sees them BEFORE they auto-apply in payroll.
export default function WageOrderBanner() {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/wage-orders/upcoming").then((r) => setItems(r.data.items || [])).catch(() => {});
    }, []);
    if (!items.length) return null;

    return (
        <div className="mb-3 rounded-lg border border-amber-300 bg-amber-50 dark:bg-amber-950/30 dark:border-amber-800 p-3">
            <div className="flex items-start gap-3">
                <CalendarClock className="size-5 text-amber-600 shrink-0 mt-0.5" />
                <div className="flex-1">
                    <div className="font-display font-semibold text-amber-900 dark:text-amber-200 text-sm">
                        Scheduled minimum-wage adjustment{items.length > 1 ? "s" : ""}
                    </div>
                    <ul className="mt-1 space-y-1">
                        {items.map((t) => (
                            <li key={`${t.wage_order_id}-${t.seq}`} className="text-xs text-amber-800 dark:text-amber-300">
                                <span className="font-medium">{t.order_no || t.title} — {t.region}</span>:
                                {" "}+₱{Number(t.increase).toFixed(2)}/day → new floor ₱{Number(t.resulting_floor).toFixed(2)}
                                {" "}effective {formatDate(t.effective_date)}
                                {" "}
                                {t.status === "effective"
                                    ? <span className="badge badge-approved ml-1">now in effect</span>
                                    : <span className="ml-1 font-semibold">
                                        {t.days_until === 0 ? "(takes effect today)" : `(in ${t.days_until} day${t.days_until === 1 ? "" : "s"})`}
                                      </span>}
                            </li>
                        ))}
                    </ul>
                    <button
                        className="mt-1 text-xs text-amber-700 dark:text-amber-300 underline"
                        onClick={() => navigate("/admin/minimum-wages")}
                    >
                        View wage orders
                    </button>
                </div>
            </div>
        </div>
    );
}
